import { Flex, Spinner, Text, Box } from '@chakra-ui/react';

const FullPageLoader = ({ text = "Loading" }) => {
    return (
        <Flex
            position="fixed"
            inset="0"
            bg="blackAlpha.600"
            alignItems="center"
            justifyContent="center"
        >
            <Box
                bg="gray.800"
                borderRadius="lg"
                p={8}
            >
                <Flex
                    direction="column"
                    align="center"
                    gap={4}
                >
                    <Spinner
                        thickness="4px"
                        speed="0.65s"
                        emptyColor="gray.600"
                        color="gray.100"
                        size="xl"
                    />
                    <Text
                        color="gray.100"
                        fontSize="lg"
                        fontWeight="medium"
                    >
                        {text}
                    </Text>
                </Flex>
            </Box>
        </Flex>
    );
};

export default FullPageLoader;